import React, {useMemo} from 'react';
import {Freeze} from 'react-freeze';

import BenchlingProfiler, {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {toDatadogTagFormat} from 'performance/PerformanceUtils';
import {CONTENT_RENDER_FINISHED_EVENT, CONTENT_RENDER_STARTED_EVENT} from 'performance/processNotebookEvents';

import {VirtualizableProps} from './Virtualizable';
import {VirtualizationState} from './VirtualizationState';

export type RevirtualizableProps = VirtualizableProps;

export default ({
  eventId,
  contentType,
  documentType,
  virtualizationState,
  renderVirtualizedSkeleton,
  renderDevirtualizedItem,
}: RevirtualizableProps): JSX.Element => {
  const extra: Record<string, unknown> = {
    distributionMetadata: {
      content_type: toDatadogTagFormat(contentType),
      document_type: toDatadogTagFormat(documentType),
      virtualization_state: toDatadogTagFormat(virtualizationState.toLowerCase()),
    },
  };

  logProfilerTimingEvent({...CONTENT_RENDER_STARTED_EVENT, id: eventId}, extra);

  const isVirtualized = virtualizationState === VirtualizationState.VIRTUALIZED;
  const isRevirtualized = virtualizationState === VirtualizationState.REVIRTUALIZED;
  const skeleton = useMemo(renderVirtualizedSkeleton, [renderVirtualizedSkeleton]);
  const item = useMemo(
    () => (isVirtualized ? null : renderDevirtualizedItem()),
    [renderDevirtualizedItem, isVirtualized]
  );

  return (
    <BenchlingProfiler {...CONTENT_RENDER_FINISHED_EVENT} id={eventId} extra={extra}>
      {isVirtualized ? (
        skeleton
      ) : (
        <Freeze placeholder={skeleton} freeze={isRevirtualized}>
          {item}
        </Freeze>
      )}
    </BenchlingProfiler>
  );
};
